import React, { useEffect, useState } from 'react';
import { StyleSheet, View, FlatList, Pressable, TouchableOpacity, Alert, SafeAreaView, ScrollView, TouchableWithoutFeedback } from 'react-native';
import { TextInput, Text, Button } from 'react-native-paper';
import { useNavigation } from '@react-navigation/native';
import Fondo from '../modules/component/Fondo';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import theme from './../../lib/theme.js';
import { apiFetch } from '../modules/api';

const Lotes = (props) => {
  const { setSnackBarVisble, setModalVisible } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filteredDataSource, setFilteredDataSource] = useState([]);
  const [masterDataSource, setMasterDataSource] = useState([]);

  const navigation = useNavigation();

  const showAlert = () =>

    Alert.alert('La información se guardo de manera exitosa', 'Oprima Aceptar para continuar', [
      {
        text: "Aceptar",
        onPress: () => navigation.goBack()
      }
    ],
      { cancelable: true });



  function onCheckmarkPress(valor) {
    gLote = valor;
    setModalVisible(false);
  }

  const [lotes, setLotes] = useState(null);

  useEffect(function () {

    let mounted = true;
    async function fetchData() {
      if (mounted) {
        const datos = '{"operador" : "' + gOperador + '","determinante" : "' + gDeterminante + '", "upc" : "' + gUpc + '"}'

        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: datos

        }

        const response = await apiFetch(gApiPath + "/api/listarLotes", requestOptions);
        const json = await response.json();
        setLotes(json.datos);
        setFilteredDataSource(json.datos);
        setMasterDataSource(json.datos);
        gCheckbox = {};
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
        
      }
    }

    fetchData();
    return () => mounted = false;

  }, []);

  const searchFilterFunction = (text) => {
    // Check if searched text is not blank
    if (text) {
      // Inserted text is not blank
      // Filter the masterDataSource and update FilteredDataSource
      const newData = masterDataSource.filter(function (item) {
        // Applying filter for the inserted text in search bar
        let textoBuscar = item.lote + " - " + item.fecha_caducidad;
        const itemData = textoBuscar
          ? textoBuscar.toUpperCase()
          : ''.toUpperCase();
        const textData = text.toUpperCase();
        return itemData.indexOf(textData) > -1;
      });
      setFilteredDataSource(newData);
      setSearch(text);
    } else {
      // Inserted text is blank
      // Update FilteredDataSource with masterDataSource
      setFilteredDataSource(masterDataSource);
      setSearch(text);
    }
  };

  const ItemView = ({ item }) => {
    return (
      // Flat List Item
      <Text style={styles.itemStyle} onPress={() => getItem(item)}>
        {item.id}
        {'.'}
        {item.title.toUpperCase()}
      </Text>
    );
  };



  const getItem = (item) => {
    // Function for click on an item
    alert('Id : ' + item.id + ' Title : ' + item.title);
  };

  function formatoLote(lote, separador, fecha) {

    let respuesta = "";

    if (lote.toLowerCase() != "sin lote" && lote.toLowerCase() != "lote no encontrado") {

      respuesta = lote + separador + fecha;

    } else {

      respuesta = lote;

    }

    return respuesta




  }

  const Spacer = ({ height = 16 }) => <View style={{ height }} />;
  return (
    <View style={{ width: '100%', minHeight: 200 }}>
      <Text style={{ ...theme.subTitle, fontWeight: 'bold', textAlign: 'center' }}>Listado de Lotes</Text>
      <View style={{ marginTop: "5%" }}>
        <View style={{ minWidth: '100%', height: 50, marginBottom: "5%" }}>
          <View style={{ alignItems: 'center', flexDirection: 'row', flex: 1, justifyContent: 'center', }}>
            <MaterialCommunityIcons name="text-box-search-outline" size={30} color="#999" style={{ marginRight: "5%" }} />
            <TextInput
              style={{ minWidth: "80%" }}
              onChangeText={(text) => searchFilterFunction(text)}
              value={search}
              label="Buscar..."
              mode='outlined'
            />
          </View>
        </View>
      </View>
      <View style={{ maxHeight: 300, marginBottom: "5%" }}>
        {!isLoading ? (
          <ScrollView style={{marginBottom: "10%"}}>
            <FlatList
              style={{ flex: 1 }}
              data={filteredDataSource}
              keyExtractor={(item, index) => index.toString()}
              renderItem={({ item }) =>
                <View style={styles.checkboxContainer}>
                  <TouchableOpacity
                    style={{ ...theme.cards, backgroundColor: theme.colors.primary, textAlign: 'center', width: '95%', }}
                    onPress={() => onCheckmarkPress(formatoLote(item.lote, " - ", item.fecha_caducidad))}>
                    <Text style={styles.titulo2}>  {formatoLote(item.lote, " - ", item.fecha_caducidad)}</Text>
                  </TouchableOpacity>
                </View>}
            />
          </ScrollView>
        ) : (
          <Text>Cargando...</Text>
        )}
        <TouchableWithoutFeedback >
          <Button onPress={() => setModalVisible(false)} disabled={isLoading} mode="contained" style={isLoading ? {} : theme.buttons.error}>
            Cerrar
          </Button>
        </TouchableWithoutFeedback>
      </View>
      
    </View>
  );
}



export default Lotes

const styles = StyleSheet.create({

  titulo: {
    fontSize: 25,
    color: "white",
    fontWeight: 'bold',
    marginTop: 10,
  }, text: {
    fontSize: 15,
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase'
  },

  titulo2: {
    fontSize: 25,
    color: "white",
    fontWeight: 'bold'
  },

  titulo3: {
    fontSize: 30,
    color: "black",
    fontWeight: 'bold'
  },
  button: {

    padding: 5,
    width: '100%',
    height: '95%',
    borderRadius: 10,
    fontWeight: 'bold',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 5,
    marginBottom: 5

  },
  container2: {
    flex: 1,
    marginTop: 10,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',

  }, checkboxBase: {
    width: "100%",
    height: 70,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 10,
    backgroundColor: '#4c669f',
  }, container5: {

    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 20,
    width: '80%'
  },

  checkboxChecked: {
    backgroundColor: 'coral',
  },

  checkboxContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    textAlign: 'center',
    height: '100%'
  },
  itemStyle: {
    padding: 10,
  },
  textInputStyle: {
    width: '50%',
    height: 50,
    borderWidth: 1,
    paddingLeft: 20,
    margin: 5,
    borderColor: '#009688',
    backgroundColor: '#FFFFFF',
    borderRadius: 10,
    fontSize: 20,
    fontWeight: 'bold',
  },


});


